import React from 'react';

const CloseIcon: React.FunctionComponent = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.75781 17.7428L12.0008 12.4998L17.2438 17.7428M17.2438 7.25684L11.9998 12.4998L6.75781 7.25684"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CloseIcon;
